/* WARNING: pass `borderRadius` inline if needed for Safari  */
import React, { Component } from 'react';
import classes from './LazyImage.module.css';
// import { isMobile, isAndroid, isIOS, osVersion } from 'react-device-detect';

class LazyImage extends Component {
  state = {
    loaded: false,
    src: null
  };

  componentDidMount () {
    if (this.props.lazy && 'IntersectionObserver' in window) {
      this.setObserver();
    } else {
      this.setPreloader();
    }
  }
  componentWillUnmount () {
    if (this.observer) {this.observer.disconnect();}
    if (this.preloader) {this.preloader.onload = null;}
  }

  setObserver = () => {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.setPreloader();
          this.observer.disconnect();
        }
      });
    });

    this.observer.observe(this.el);
  }
  setPreloader = () => {
    this.preloader = new Image();

    this.preloader.onload = () => {
      if (this.props.srcLoaded) {
        this.setState({
          loaded: true,
          src: `url(${this.props.srcLoaded})`
        });
      } else {
        this.setState({ loaded: true });
      }
    }

    this.preloader.src = this.props.srcLoaded;
  }

  render () {
    // do not lazy-load on Android below version 7 and iOS below version 9
    // let version = osVersion.split('.');
    let lazyImg;
    /* if (
      this.props.notLazy
      ||
      (
        isMobile &&
        (
          (isAndroid && version[0] < 7) ||
          (isIOS && version[0] < 9)
        )
      )
    ) { */
    lazyImg = (
      <img
        className={classes.LazyImage}
        src={this.props.srcLoaded}
        alt={this.props.title || 'Member'}
        title={this.props.title}
        style={this.props.lazyImgStyle}
      />
);
    /* } else {
      lazyImg = (
        <div style={{
          position: 'absolute',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          backgroundImage: this.state.src,
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
          borderRadius: 'inherit',
          opacity: this.state.loaded ? 1 : 0,
          transition: `opacity ${this.props.duration || '.3s'} ${this.props.ease || 'cubic-bezier(0.215, 0.61, 0.355, 1)'}`
        }} title={this.props.title} />
      );
    } */
    return (
      <div
        // Required: Relative, absolute, or fixed position
        // Required: Width & height (explicitly or via top/right/bottom/left)
        // Optional: Background color or placeholder image
        className={classes.LazyImage}
        style={{ ...this.props.style }}
        ref={(el) => { this.el = el; }}
      >
        {lazyImg}
      </div>
    );
  }
}

export default LazyImage;



// WEBPACK FOOTER //
// ./src/components/UI/LazyImage/LazyImage.js